import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
// react plugin for creating notifications
import NotificationAlert from "react-notification-alert";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.jsx";

import routes from "routes.js";
// import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var ps;

class Admin extends React.Component {
  state = {
    sidebarMini: true,
    loading: false,
    show:false,
    // backgroundColor: "navyblue"
    backgroundColor: "navyblue"
  };
  notificationAlert = React.createRef();
  mainPanel = React.createRef();

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.mainPanel.current);
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.className += " perfect-scrollbar-off";
      document.documentElement.classList.remove("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.mainPanel.current.scrollTop = 0;
    }
  }
  minimizeSidebar = () => {
    // var message = "Sidebar mini ";
    if (document.body.classList.contains("sidebar-mini")) {
      this.setState({ sidebarMini: false });
      // message += "deactivated...";
    } else {
      this.setState({ sidebarMini: true });
      // message += "activated...";
    }
    document.body.classList.toggle("sidebar-mini");
    // var options = {};
    // options = {
    //   place: "tr",
    //   message: message,
    //   type: "info",
    //   icon: "now-ui-icons ui-1_bell-53",
    //   autoDismiss: 7
    // };
    // this.notificationAlert.current.notificationAlert(options);
  };
  handleColorClick = color => {
    this.setState({ backgroundColor: color });
  };
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/admin" || prop.layout === "/") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  getActiveRoute = routes => {
    let activeRoute = "Default Brand Text";
    if (localStorage.getItem("menuOrder") !== null) {
      let customMenuList = JSON.parse(localStorage.getItem("menuOrder"));
      for (let a = 0; a < customMenuList.length; a++) {
        var fromIndex = routes.findIndex(item => item.name === customMenuList[a].displayName);
        var toIndex = a;
        var item = routes.splice(fromIndex, 1);
        // Move the item to its new position
        routes.splice(toIndex, 0, item[0]);
      }
    }
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.pathname.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

 showToast = () => {
  this.setState({ show:true});
  };

 hideToast = () => {
  this.setState({ show:false});
  };


  render() {
    return (
      <div className="wrapper">
     
        <NotificationAlert ref={this.notificationAlert} />
        {localStorage.getItem("accessToken") !== null && <Sidebar
          {...this.props}
          routes={routes}
          minimizeSidebar={this.minimizeSidebar}
          backgroundColor={this.state.backgroundColor}
        />}
        <div className="main-panel" ref={this.mainPanel}>
      
          <AdminNavbar
            {...this.props}
            brandText={this.getActiveRoute(routes)}
          />
          <Switch>
            {this.getRoutes(routes)}
            <Redirect from="/" to="/project" />
          </Switch>
          {// we don't want the Footer to be rendered on full screen maps page
          window.location.href.indexOf("full-screen-maps") !== -1 ? null : (
            <Footer fluid />
          )}
        </div>
        <FixedPlugin
          handleMiniClick={this.minimizeSidebar}
          sidebarMini={this.state.sidebarMini}
          bgColor={this.state.backgroundColor}
          handleColorClick={this.handleColorClick}
        />
      </div>
    );
  }
}

export default Admin;
